import { RefreshCw, Sparkles } from 'lucide-react';
import type { GameRelease } from '../../shared/game-releases';

export function GameReleaseBadge({ release }: { release: GameRelease }) {
  const Icon = release.kind === 'new' ? Sparkles : RefreshCw;
  return (
    <span className={`latest-game-badge ${release.kind}`}>
      <Icon size={12} />
      {release.kind === 'new' ? '新上架' : '更新'}
    </span>
  );
}

export function GameReleaseTime({ release }: { release: GameRelease }) {
  const date = new Date(release.at);
  return (
    <time
      className="latest-game-time"
      dateTime={release.at}
      title={new Intl.DateTimeFormat('zh-CN', {
        timeZone: 'Asia/Shanghai',
        dateStyle: 'full',
      }).format(date)}
    >
      {new Intl.DateTimeFormat('zh-CN', {
        timeZone: 'Asia/Shanghai',
        month: '2-digit',
        day: '2-digit',
      }).format(date)}{' '}
      {release.kind === 'new' ? '上架' : '更新'}
    </time>
  );
}
